import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'src/domains/common/components/button/button';
import { InputField } from 'src/components/LicenseConfig/shared/InputField/InputField';
import { AutoLogoutState } from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogout.state';
import {
    AutoLogoutActions,
    AutoLogoutFormFields,
    AutoLogoutFormLabel,
    AutoLogoutFormRow,
    AutoLogoutFormValue,
    AutoLogoutSection,
    AutoLogoutSectionTitle,
    AutoLogoutUnitSuffix,
} from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogout.style';

interface AutoLogoutFormPropsType {
    state: AutoLogoutState;
}

export const AutoLogoutForm = observer(({ state }: AutoLogoutFormPropsType): JSX.Element => {
    const hasErrors = state.durationHours.result.value.type === 'error';

    const handleSubmit = (event: React.FormEvent): void => {
        event.preventDefault();
        void state.updateConfig();
    };

    return (
        <AutoLogoutSection data-test='compliance-configuration-auto-logout-form'>
            <AutoLogoutSectionTitle>Session inactivity timeout</AutoLogoutSectionTitle>
            <form onSubmit={handleSubmit}>
                <AutoLogoutFormFields>
                    <AutoLogoutFormRow>
                        <AutoLogoutFormLabel htmlFor='auto-logout-duration-hours'>
                            Auto logout after
                        </AutoLogoutFormLabel>
                        <AutoLogoutFormValue>
                            <InputField
                                formInputState={state.durationHours}
                                disabled={state.isSaving}
                                originalValue={state.originalHoursValue}
                                name='auto-logout-duration-hours'
                                placeholder='6'
                                allowedPattern={/^\d*\.?\d*$/}
                                inputMode='decimal'
                            />
                            <AutoLogoutUnitSuffix>hours</AutoLogoutUnitSuffix>
                        </AutoLogoutFormValue>
                    </AutoLogoutFormRow>
                </AutoLogoutFormFields>
                <AutoLogoutActions>
                    <Button
                        dataTest='compliance-configuration-auto-logout-submit'
                        disabled={state.isSaving || hasErrors}
                        isLoading={state.isSaving}
                        type='submit'
                    >
                        Save configuration
                    </Button>
                </AutoLogoutActions>
            </form>
        </AutoLogoutSection>
    );
});
